import styled, { css } from 'styled-components';

import { Select } from 'components/Select/Select';
import { colors } from 'theme/theme';

const greyVariantCss = css`
  background: ${colors.inputGrey};
  color: ${colors.brandBlue};

  .react-select__control {
    border: none;
    background: ${colors.inputGrey};
  }

  .react-select__single-value {
    color: ${colors.brandBlue};
  }
`;

const outlineBlueVariantCss = css`
  color: ${colors.brandBlue};
  border: 1px solid ${colors.elementGrey};

  .react-select__control {
    border: none;
  }

  .react-select__single-value {
    color: ${colors.brandBlue};
  }
`;

export const ListingTypeSelectStyled = styled(Select)<{
  $variant: 'grey' | 'outline-blue';
}>`
  border-radius: 8px;
  border: none;

  ${(props) =>
    props.$variant === 'grey' ? greyVariantCss : outlineBlueVariantCss}
`;
